// extracted by mini-css-extract-plugin
module.exports = {"heading":"sportContainer_heading__Cogl3","lowerArea":"sportContainer_lowerArea__CKEUA","section":"sportContainer_section__tauSw","recent":"sportContainer_recent__0DYuV"};